var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MovingRingNoData"},[_c('img',{staticStyle:{"width":"250px"},attrs:{"src":require("@/assets/img/upgrade.svg")}}),_c('p',[_vm._v("哎呀，暂无可显示的数据哦，赶紧去添加吧！")])])
}]

export { render, staticRenderFns }